import axios from '@/services/axios'
import { requestToken } from '@/services/image/token'
import * as ImageKit from '@/services/image/imagekit'

// const URL = {
//   banner: '/data/private/banner',
//   reseller: '/data/private/resellerbannerlist',
// }

/**
 * @this {import('vuex').Store}
 *
 * @param {import('vuex').ActionContext} param0
 * @param {any} payload
 */
export async function GET_BANNER({ commit, state, rootState }, { type = 'banner' }) {
  commit('FETCHING', true)
  commit('SET', {
    key: 'images',
    payload: [],
  })

  try {
    const { data: response } = await axios.get('/data/private/banner')
    commit('FETCHING', false)
    commit('SET', {
      key: 'images',
      payload: response.message,
    })
    return Promise.resolve(response.message)
  } catch (err) {
    commit('FETCHING', false)
    commit('SET', {
      key: 'images',
      payload: [],
    })
    return Promise.reject(new Error(err?.response?.message || err?.message))
  }
}

/**
 * Remove Banner
 *
 * @this {import('vuex').Store}
 *
 * @param {import('vuex').ActionContext} context
 * @param {any} payload
 */
export async function REMOVE_BANNER({ commit, dispatch }, { id }) {
  commit('FETCHING', true)

  try {
    await axios.delete(`/data/private/banner/${id}`)
    commit('FETCHING', false)
    Promise.resolve(true)
  } catch (err) {
    commit('FETCHING', false)
    Promise.reject(err)
  }
}

export async function UPLOAD_BANNER({ commit, dispatch }, { file, type, redirectUrl }) {
  try {
    const [token] = await requestToken()
    // // eslint-disable-next-line no-unused-vars
    const imageKitResponse = await ImageKit.upload({
      file,
      expire: token.expire,
      folder: token.image_path,
      signature: token.signature,
      token: token.token,
      publicKey: token.public_key,
    })

    const imageData = {
      'name': imageKitResponse.name,
      'size': imageKitResponse.size,
      'type': imageKitResponse.fileType,
      'path': token.image_path,
      'ref_id': imageKitResponse.fileId,
      'content_id': type,
      'image_redirecturl': redirectUrl,
    }

    const { data: response } = await axios.post('/data/private/banner', {
      image_data: [imageData],
    })

    return Promise.resolve(response)
  } catch (err) {
    return Promise.reject(err)
  }
}
